import styled from "styled-components";
import Text from "../../styles/Text";
import Color from "../../assets/Colors";
import {Link} from "react-router-dom";

export const Section = styled.section`
   width: 40%;
   box-sizing: border-box;
   display: flex;
   flex-direction: column;
   justify-content: flex-end;

   @media screen and (max-width: 600px) {
      // padding: 0 0.8em;
      & .mobileFlex {
         display: flex;
         justify-content: space-between;
         align-items: center;
         & .min {
            & p {
               font-size: 0.8em;
               white-space: nowrap;
            }
            &:nth-child(2) {
               padding-left: 0.9em;
            }
         }
      }
   }
`;
export const Foot = styled.footer`
   padding: 3em 0;
   .footerContainer {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      flex-wrap: wrap;
   }
   background: linear-gradient(
      to bottom,
      rgba(207, 207, 207, 0.6) 0%,
      rgba(227, 227, 227, 0.5) 5%,
      rgba(242, 242, 242, 0.4) 17%,
      rgba(242, 242, 242, 0.3) 24%,
      rgba(242, 242, 242, 0.2) 100%
   );

   @media screen and (max-width: 600px) {
      padding: 0.5em 0;
   }
   & ${Section}:nth-child(1) {
      width: 25%;
   }
   & ${Section}:nth-child(2) {
      width: 70%;
   }
   @media screen and (max-width: 600px) {
      & ${Section}:nth-child(1),
      & ${Section}:nth-child(2) {
         width: 100%;
      }
   }
`;

export const LogoFooter = styled.div`
   margin: 1em 0;
   & img {
      width: 50px;
   }
   @media screen and (max-width: 600px) {
      width: 45px;
      margin-right: 15px;
      & img {
         width: 100%;
      }
      display: inline;
   }
`;

export const TitleFooter = styled(Text)`
   font-size: 1.3em;
   margin: 1em 0;
   font-weight: 200;
   color: ${Color.textColor};

   @media screen and (max-width: 1600px) {
      font-size: 0.9em;
   }
   @media screen and (max-width: 600px) {
      font-size: 0.9em;
   }
`;

export const SubtitleFooter = styled(Text)`
   font-size: 0.9em;
   color: rgba(95, 100, 120, 0.9);
   margin: 0;
   font-weight: 300;
   text-decoration: none;

   @media screen and (max-width: 1600px) {
      &.form {
         letter-spacing: 1px;
      }
   }
`;

export const SubtitleLink = styled(Link)`
   font-size: 0.9em;
   color: rgba(95, 100, 120, 0.9);
   margin: 0;
   font-weight: 300;
   text-decoration: none;

   @media screen and (max-width: 1600px) {
      &.form {
         letter-spacing: 1px;
      }
   }
`;

export const FormSubmit = styled.form`
   width: 100%;
   border-bottom: 1px solid grey;
   margin-top: 1em;
   & .align {
      display: flex;
      align-items: baseline;
   }
`;

export const InputForm = styled.input`
   font-size: 1em;
   outline: none;
   border: none;
   padding: 0.5em;
   color: grey;
   background: transparent;
   width: 90%;
   font-weight: 100;

   :-webkit-autofill,
   :-webkit-autofill:hover,
   :-webkit-autofill:focus {
      // border: none;
      -webkit-text-fill-color: ${Color.textColor};
      -webkit-box-shadow: 0 0 0px 1000px white inset;
      transition: background-color 5000s ease-in-out 0s;
   }

   @media screen and (max-width: 500px) {
      font-size: 0.85em
   }
`;
export const ButtonSubmit = styled.button`
   background: transparent;
   outline: none;
   border: none;
   cursor: pointer;

   @media screen and (min-width: 768px) {
      &:hover:not(.noHover) {
         color: white;
         background: ${Color.primary};
         & .icon {
            fill: white;
         }
         transition: all 420ms;
      }
   }

   & img {
      width: 0.8em;
      height: 0.8em;
   }
`;
export const SimpleText = styled(Text)`
   width: 90%;
   font-size: 0.8em;
   line-height: 1.5em;
   color: ${Color.textColor};
   margin: 1em 0 0 0;
   @media screen and (max-width: 1600px) {
      width: 96%;
      font-size: 0.78em;
   }
`;

export const RowFooter = styled.div`
   display: flex;
   align-items: flex-start;
   @media screen and (max-width: 600px) {
      flex-direction: column;
   }
   &.second {
      align-items: baseline;
   }
`;

export const ColFooter = styled.div`
   width: 30%;
   margin-top: 3em;

   &:nth-child(3) {
      margin-left: 10%;
   }
   @media screen and (max-width: 500px) {
      width: 100%;
      margin-top: 1em;
      display: flex;
      flex-direction: column;
      margin: 1em 0;
      :nth-child(3) {
         margin-left: 0;
      }
   }
`;

export const Logos = styled.div`
   margin-top: 2em;
   & img {
      width: 45px;
      height: 45px;
   }
   & img:first-child {
      margin-right: 2em;
   }
`;
